import type {ShopperDto, ShopperTokenDto} from 'types/Dto';

import {GET, POST} from 'utils/Http';

import API from 'constants/api';

export const createShopperAuth = (didToken: string) => {
  return POST<ShopperTokenDto>(API.SHOPPERS_AUTH, {
    headers: {
      'X-Magic-Token': `Bearer ${didToken}`,
    },
  });
};

export const fetchShopperAuth = () => {
  return GET<ShopperDto>(API.SHOPPERS_AUTH);
};
